/**
 * 营销账户 | 广告 | 保险
 */
import Net from '../net';

const NAME = '[MarketingApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === MarketingAccount === **/
/** account/ad-account-stat
 * @param {Object} data
*/
export async function getMarketingAccountDetail(data = {}) {
  Log('getMarketingAccountDetail data:', data)
  try {
    const res = await Net.http('account/ad-account-stat', { data })
    Log('getMarketingAccountDetail res:', res)
    return res
  } catch (err) {
    Log('getMarketingAccountDetail err:', err)
    throw err
  }
}

/** account/stat-alipay-account-money-by-time
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function marketingAccountMoneyByTime(data = {}) {
  Log('marketingAccountMoneyByTime data:', data)
  try {
    const res = await Net.http('account/stat-alipay-account-money-by-time', { data })
    Log('marketingAccountMoneyByTime res:', res)
    return res
  } catch (err) {
    Log('marketingAccountMoneyByTime err:', err)
    throw err
  }
}

/** account/alipay-ad-account-operate
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.type
 * @param {*} data.money
*/
export async function marketingAccountOperate(data = {}) {
  Log('marketingAccountOperate data:', data)
  try {
    const res = await Net.http('account/alipay-ad-account-operate', { data })
    Log('marketingAccountOperate res:', res)
    return res
  } catch (err) {
    Log('marketingAccountOperate err:', err)
    throw err
  }
}

/** alipay-ad-order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.id
 * @param {*} data.biz_id
 * @param {*} data.order_sn
 * @param {*} data.order_type
 * @param {*} data.status
 * @param {*} data.user_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.use_begin_time
 * @param {*} data.use_end_time
*/
export async function marketingAccountOrderList(data = {}) {
  Log('marketingAccountOrderList data:', data)
  try {
    const res = await Net.http('alipay-ad-order/list', { data })
    Log('marketingAccountOrderList res:', res)
    return res
  } catch (err) {
    Log('marketingAccountOrderList err:', err)
    throw err
  }
}

/** alipay-ad-order/detail-by-power-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function marketingAccountOrderDetail(data = {}) {
  Log('marketingAccountOrderDetail data:', data)
  try {
    const res = await Net.http('alipay-ad-order/detail-by-power-order', { data })
    Log('marketingAccountOrderDetail res:', res)
    return res
  } catch (err) {
    Log('marketingAccountOrderDetail err:', err)
    throw err
  }
}


/** === Advertising === **/
/** ad_config/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.scene
 * @param {*} data.vendor
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getAdvertisingList(data = {}) {
  Log('getAdvertisingList data:', data)
  try {
    const res = await Net.http('ad_config/list', { data })
    Log('getAdvertisingList res:', res)
    return res
  } catch (err) {
    Log('getAdvertisingList err:', err)
    throw err
  }
}

/** ad_config/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.scene
 * @param {*} data.score
 * @param {*} data.url
 * @param {*} data.vendor
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function saveAdvertising(data = {}) {
  Log('saveAdvertising data:', data)
  try {
    const res = await Net.http('ad_config/save', { data })
    Log('saveAdvertising res:', res)
    return res
  } catch (err) {
    Log('saveAdvertising err:', err)
    throw err
  }
}

/** ad_config/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteAdvertising(data = {}) {
  Log('deleteAdvertising data:', data)
  try {
    const res = await Net.http('ad_config/delete', { data })
    Log('deleteAdvertising res:', res)
    return res
  } catch (err) {
    Log('deleteAdvertising err:', err)
    throw err
  }
}

/** ad_log/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.resource_id
 * @param {*} data.ad_id
 * @param {*} data.channel
 * @param {*} data.type
 * @param {*} data.user_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function advertisingLog(data = {}) {
  Log('advertisingLog data:', data)
  try {
    const res = await Net.http('ad_log/list', { data })
    Log('advertisingLog res:', res)
    return res
  } catch (err) {
    Log('advertisingLog err:', err)
    throw err
  }
}


/** === AdverRule === **/
/** ad-rule/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getAdverRuleList(data = {}) {
  Log('getAdverRuleList data:', data)
  try {
    const res = await Net.http('ad-rule/list', { data })
    Log('getAdverRuleList res:', res)
    return res
  } catch (err) {
    Log('getAdverRuleList err:', err)
    throw err
  }
}

/** ad-rule/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_id
 * @param {*} data.config
*/
export async function saveAdverRule(data = {}) {
  Log('saveAdverRule data:', data)
  try {
    const res = await Net.http('ad-rule/save', { data })
    Log('saveAdverRule res:', res)
    return res
  } catch (err) {
    Log('saveAdverRule err:', err)
    throw err
  }
}

/** ad-rule/detail
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_id
*/
export async function getAdverRuleDetail(data = {}) {
  Log('getAdverRuleDetail data:', data)
  try {
    const res = await Net.http('ad-rule/detail', { data })
    Log('getAdverRuleDetail res:', res)
    return res
  } catch (err) {
    Log('getAdverRuleDetail err:', err)
    throw err
  }
}

/** ad-rule/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteAdverRule(data = {}) {
  Log('deleteAdverRule data:', data)
  try {
    const res = await Net.http('ad-rule/delete', { data })
    Log('deleteAdverRule res:', res)
    return res
  } catch (err) {
    Log('deleteAdverRule err:', err)
    throw err
  }
}

/** ad-rule/batch-delete
 * @param {Object} data
 * @param {*} data.ids
*/
export async function batchDeleteAdverRule(data = {}) {
  Log('batchDeleteAdverRule data:', data)
  try {
    const res = await Net.http('ad-rule/batch-delete', { data })
    Log('batchDeleteAdverRule res:', res)
    return res
  } catch (err) {
    Log('batchDeleteAdverRule err:', err)
    throw err
  }
}


/** === Insurance === **/
/** insurance/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.order_sn
 * @param {*} data.status
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getInsuranceList(data = {}) {
  Log('getInsuranceList data:', data)
  try {
    const res = await Net.http('insurance/list', { data })
    Log('getInsuranceList res:', res)
    return res
  } catch (err) {
    Log('getInsuranceList err:', err)
    throw err
  }
}

/** insurance/refund
 * @param {Object} data
 * @param {*} data.id
*/
export async function insuranceRefund(data = {}) {
  Log('insuranceRefund data:', data)
  try {
    const res = await Net.http('insurance/refund', { data })
    Log('insuranceRefund res:', res)
    return res
  } catch (err) {
    Log('insuranceRefund err:', err)
    throw err
  }
}

/** insurance/alipay-insurance-pre-order
 * @param {Object} data
 * @param {*} data.id
*/
export async function insurancePreOrder(data = {}) {
  Log('insurancePreOrder data:', data)
  try {
    const res = await Net.http('insurance/alipay-insurance-pre-order', { data })
    Log('insurancePreOrder res:', res)
    return res
  } catch (err) {
    Log('insurancePreOrder err:', err)
    throw err
  }
}

/** insurance/alipay-insurance-sync
 * @param {Object} data
 * @param {*} data.id
*/
export async function insuranceAdvanceOrder(data = {}) {
  Log('insuranceAdvanceOrder data:', data)
  try {
    const res = await Net.http('insurance/alipay-insurance-sync', { data })
    Log('insuranceAdvanceOrder res:', res)
    return res
  } catch (err) {
    Log('insuranceAdvanceOrder err:', err)
    throw err
  }
}

/** insurance/detail
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.order_type
*/
export async function getInsuranceDetail(data = {}) {
  Log('getInsuranceDetail data:', data)
  try {
    const res = await Net.http('insurance/detail', { data })
    Log('getInsuranceDetail res:', res)
    return res
  } catch (err) {
    Log('getInsuranceDetail err:', err)
    throw err
  }
}


/** === VenueInsurance === **/
/** insurance/list-operator
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.status
 * @param {*} data.suid
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getVenueInsuranceList(data = {}) {
  Log('getVenueInsuranceList data:', data)
  try {
    const res = await Net.http('insurance/list-operator', { data })
    Log('getVenueInsuranceList res:', res)
    return res
  } catch (err) {
    Log('getVenueInsuranceList err:', err)
    throw err
  }
}

/** insurance/set-mark
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.data
*/
export async function venueInsuranceRemark(data = {}) {
  Log('venueInsuranceRemark data:', data)
  try {
    const res = await Net.http('insurance/set-mark', { data })
    Log('venueInsuranceRemark res:', res)
    return res
  } catch (err) {
    Log('venueInsuranceRemark err:', err)
    throw err
  }
}
